import React, { useContext, useEffect, useState } from 'react';
import { getSubCategory, getCategory, deleteSubCategory, updateSubCategory } from '../../../Utility/Api';
import { toast } from 'react-toastify';
import '../../../Utility/pagination.css'
import { EditSubCategory } from './from';
import { Deletemodel, Pagination } from '../../Common/Functions'
import { isReadonlyRoute, NaviGate } from '../../../Utility/function';
import { WarehouseContext } from '../../../Utility/UserContext';
import { useLocation } from 'react-router-dom';

const Subcategory_list = () => {
    const { pathname } = useLocation();
    const readonly = isReadonlyRoute(pathname);
    const { showLoader, hideLoader } = useContext(WarehouseContext);
    const [subcategory, setSubCategory] = useState([]);
    const [category, setCategory] = useState([]);
    const [formData, setFormData] = useState({ subcategory: '', category_id: '', status: '' });
    const [showModal, setShowModal] = useState(false);
    const [selectedsubCategory, setSelectedSubCategory] = useState(null);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [addoredit, setaddoredit] = useState()
    const [deleteID, setDeleteID] = useState("");
    const [deletemodel, showDeletemodel] = useState(false)
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const rolesPerPage = 10;

    useEffect(() => {
        fetchSubCategory();
        fetchCategory();
    }, []);

    const handledeletemodel = (ID) => {
        showDeletemodel(true);
        setDeleteID(ID);
    };

    const fetchSubCategory = async (page = 1, text = "") => {
        showLoader();
        try {
            const response = await getSubCategory(page, text);
            if (response.data && response.data.data) {
                setSubCategory(response.data.data);
                setTotalPages(response.data.pagination.total_pages); // Update total pages for pagination
                hideLoader();

            }
        } catch (error) {
            console.error('Error fetching subcategory data:', error);
            hideLoader();
        }
    };

    const fetchCategory = async () => {
        try {
            const response = await getCategory();
            if (response.data && response.data.data) {
                setCategory(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching category data:', error);
        }
    };

    const openAddModal = () => {
        setaddoredit(true)
        setShowEditModal(!showEditModal)
    };

    const openEditModal = (cat) => {
        setSelectedSubCategory(cat);
        setaddoredit(false)
        setShowEditModal(!showEditModal)
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleDelete = async () => {
        try {
            await deleteSubCategory(deleteID);
            showDeletemodel(false);
            toast.error('SubCategory is Inactivated');
            fetchSubCategory(currentPage);
        } catch (error) {
            console.error('Error deleting subcategory:', error);
            toast.error('Error deleting subcategory');
        }
    };

    const handlePageChange = (pageNumber) => {
        if (pageNumber < 1 || pageNumber > totalPages) return;
        setCurrentPage(pageNumber);
        fetchSubCategory(pageNumber);
        fetchCategory(pageNumber);

    };

    const handleSearch = async (text) => {
        fetchSubCategory(1, text);
        setCurrentPage(1);
    };

    const activateSubCategory = async (value) => {
        console.log(value);
        showLoader();
        try {
            const payload = {
                ...value,
                cat_id: value.category_id,
                subcategories: value.subcategory_name,
                status: 0
            }
            await updateSubCategory(value?.subcategory_id, payload);
            hideLoader();
            fetchSubCategory(currentPage)
            toast.success('Sub Category Activated')
        } catch (err) {
            console.error(err);
            hideLoader();
            toast.error(err.message)
        }
    };

    return (
        <div className="page-wrappers">
            <div className="page-content">
                <NaviGate />
                <div className="mb-0 d-flex justify-content-between align-items-center">
                    <h6 className="mb-0 text-uppercase" style={{ fontFamily: "poppins" }}>Subcategory List</h6>
                    {!readonly && <button
                        type="button"
                        onClick={() => openAddModal()}
                        className="btn btn-primary mb-0" style={{ fontFamily: "poppins" }}
                    >
                        Add SubCategory
                    </button>}
                </div>
                <hr className='mt-1' />

                <div className="card">
                    <div className="card-body">
                        <div className="col-12 col-md-6 col-lg-4 mb-3 mb-md-2">
                            <div className="d-flex position-relative" style={{ width: "100%" }}>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder="Search..."
                                    onChange={(e) => handleSearch(e.target.value)}
                                />
                                <img
                                    src="/assets/images/icons/search.png"
                                    alt="Search Icon"
                                    style={{
                                        position: "absolute",
                                        right: "12px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        height: "18px",
                                        pointerEvents: "none",
                                    }}
                                />
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table
                                id="example"
                                className="table table-striped  table-sm table-bordered"
                                style={{ width: "100%", fontFamily: "poppins" }}
                            >
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>SubCategory</th>
                                        <th>Category</th>
                                        {!readonly && <th>Actions</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {subcategory.map((subcat, index) => (
                                        <tr key={subcat.subcategory_id}>
                                            <td>{(currentPage - 1) * rolesPerPage + index + 1}</td>
                                            <td>{subcat.subcategory_name}</td>
                                            <td>{subcat.category_name}</td>
                                            {!readonly && <td>
                                                {subcat.status == null || subcat.status == 0 ? (
                                                    <>
                                                        <img src='/assets/images/icons/edit.png' onClick={() => openEditModal(subcat)} height="16px" alt="Edit" />
                                                        &nbsp;&nbsp;&nbsp;
                                                        <img src='/assets/images/icons/delete.png' className="mx" onClick={() => handledeletemodel(subcat.subcategory_id)} height="16px" alt="Delete" />
                                                    </>
                                                ) : (
                                                    <button className="btn btn-secondary py-1 rounded-1" style={{ fontSize: '13px' }} onClick={() => activateSubCategory(subcat)}>Inactive</button>
                                                )}
                                            </td>}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <Pagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {deletemodel && (
                <Deletemodel
                    setShowModal={showDeletemodel}
                    handleDelete={handleDelete}
                />
            )}

            <EditSubCategory showModal={showEditModal} setShowModal={() => openEditModal()} fetchSubCategory={() => fetchSubCategory()}
                selectedSubCategory={selectedsubCategory} AddorEdit={addoredit} setCurrentPage={setCurrentPage} />
        </div>
    )
}

export default Subcategory_list